<template>
  <transition id="loader" name="fade">
    <div id="respect-fade">
      <svg width="351" height="80" viewBox="0 0 351 80" xmlns="http://www.w3.org/2000/svg" v-bind:id="'respect-logo-fade'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><g fill="none" fill-rule="evenodd"><path d="M263.51 76.758c-20.288 0-36.793-16.508-36.793-36.793 0-20.284 16.505-36.788 36.793-36.788 13.38 0 25.113 7.18 31.551 17.89l-10.648 6.583c-4.227-7.148-12.013-11.952-20.903-11.952-13.383 0-24.272 10.887-24.272 24.267 0 13.384 10.89 24.272 24.272 24.272 8.89 0 16.676-4.805 20.903-11.953l10.648 6.584c-6.438 10.706-18.17 17.89-31.55 17.89zm19.61-29.01c-3.096 7.798-10.709 13.311-19.61 13.311-11.653 0-21.096-9.442-21.096-21.094 0-11.649 9.443-21.092 21.096-21.092 8.901 0 16.514 5.513 19.61 13.313l16.185-10.008C292.761 9.033 279.192.001 263.51.001c-22.075 0-39.968 17.892-39.968 39.964 0 22.074 17.893 39.968 39.968 39.968 15.682 0 29.25-9.034 35.795-22.176l-16.186-10.01z" fill="#FFF"/><path fill="#00306B" d="M298.067 65.161h.93v2.535h.63v-2.535h.93v-.552h-2.49zM303.695 64.61l-.748 2.017h-.017l-.715-2.018h-1.094v3.087h.63v-2.454h.014l.865 2.454h.612l.892-2.454h.014v2.454h.63V64.61z"/><path d="M284.413 52.283c-4.227 7.149-12.013 11.953-20.903 11.953-13.383 0-24.272-10.888-24.272-24.27s10.89-24.27 24.272-24.27c8.89 0 16.676 4.806 20.903 11.954l10.648-6.582c-6.438-10.711-18.17-17.892-31.55-17.892-20.289 0-36.794 16.504-36.794 36.79 0 20.285 16.505 36.79 36.793 36.79 13.38 0 25.113-7.181 31.551-17.889l-10.648-6.584z" fill="#CE0E2D"/><path d="M16.605 26.206H8.548v11.562h8.057c3.753 0 6.212-2.398 6.212-5.78 0-3.384-2.46-5.782-6.212-5.782zm6.643 36.163l-8.549-17.467H8.55V62.37h-8.55v-43.79h17.16c8.917 0 14.207 6.09 14.207 13.409 0 6.15-3.752 9.963-7.995 11.5l9.778 18.88h-9.901zM46.365 62.369v-43.79h28.843v7.627H54.913v10.27h17.282v7.627H54.913v10.64h20.295v7.626zM101.77 62.737c-6.642 0-11.685-1.414-15.99-5.781l5.535-5.535c2.767 2.768 6.52 3.69 10.578 3.69 5.042 0 7.75-1.906 7.75-5.411 0-1.54-.431-2.83-1.353-3.691-.863-.8-1.847-1.23-3.876-1.536l-5.29-.74c-3.75-.553-6.518-1.721-8.485-3.627-2.091-2.091-3.136-4.92-3.136-8.61 0-7.812 5.78-13.284 15.25-13.284 6.029 0 10.394 1.475 14.147 5.103l-5.413 5.352c-2.767-2.645-6.089-3.015-8.979-3.015-4.552 0-6.764 2.523-6.764 5.536 0 1.107.367 2.275 1.29 3.136.862.8 2.276 1.477 4.06 1.722l5.165.739c3.998.553 6.52 1.66 8.364 3.382 2.338 2.214 3.384 5.413 3.384 9.287 0 8.486-7.073 13.283-16.237 13.283M148.75 26.206h-7.995V38.2h7.995c3.874 0 6.335-2.4 6.335-5.966 0-3.567-2.46-6.028-6.335-6.028m.43 19.68h-8.425V62.37h-8.549v-43.79h16.975c9.04 0 14.452 6.213 14.452 13.655 0 7.442-5.412 13.652-14.452 13.652M176.971 62.369v-43.79h28.845v7.627H185.52v10.27h17.282v7.627H185.52v10.64h20.296v7.626zM339.126 26.206V62.37h-8.549V26.206H319.14V18.58h31.428v7.626z" fill="#FFF"/></g></svg>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FadeLoader",
  mounted() {
    document.documentElement.style.overflow = "hidden";
    setTimeout(() => {
      document.documentElement.style.overflow = "auto";
    }, 2000);
    const background = document.getElementById("respect-fade");
    const logo = document.getElementById("respect-logo-fade");
    background.classList.add("respectTheFade");
    logo.classList.add("respectTheLogoFade");
    setTimeout(() => {
      background.style.display = "none";
    }, 3000);
  },
  beforeDestroy() {
    document.documentElement.style.overflow = "auto";
  },
};
</script>
<style lang="scss" >
#respect-fade {
  background-image: url("~@/assets/images/bg/BG.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 999;
  opacity: 0;
  img,
  svg {
    max-width: 90vw;
  }
}
.respectTheFade {
  -webkit-animation: respectbackground 2.5s ease-in-out;
  animation: respectbackground 2.5s ease-in-out;
}
.respectTheLogoFade {
  -webkit-animation: respectthefade 2.5s ease-in-out;
  animation: respectthefade 2.5s ease-in-out;
}
@-webkit-keyframes respectthefade {
  0% {
    opacity: 0.5;
  }
  35% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes respectthefade {
  0% {
    opacity: 0.5;
  }
  35% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@-webkit-keyframes respectbackground {
  0% {
    opacity: 1;
  }
  35% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes respectbackground {
  0% {
    opacity: 1;
  }
  35% {
    opacity: 1;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>